<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
        <v-container
          v-if="currentUser.user.is_propagandist"
        >
          <v-row
            class="mb-12"
            no-gutters
          >
          <v-col md="12">
            <v-expansion-panels
              multiple
            >

              <v-expansion-panel
                v-if="Object.keys(teacher).length"
              >
              <v-expansion-panel-header>{{ $t('INFO_TEACHER') }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <TeacherCommonInfo :teacher="teacher" />
              </v-expansion-panel-content>
            </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <v-col
              cols="12"
            >
            <ValidationObserver
              ref="formTmp"
              tag="form"
              @submit.prevent="addToList"
            >
            <v-card
              class="mt-5"
            >
              <v-card-text>
            <ValidationProvider
              rules="required"
              vid="teacher_id"
              :name="$t('fields.teacher').toLowerCase()"
              v-slot="{ errors }"
            >
              <AutoComplete
                v-model="searchTeacher"
                :value="searchTeacher"
                key-value="id"
                key-name="fulltext"
                enable-chips
                enable-clearable
                enable-autofocus
                :items="teachers"
                :label="$t('fields.teacher')"
                @search="searchTeachers"
                @input="fetchTeacherAndSchool"
                @clear="clearTeacher"
                :loading="loading"
                :delay="900"
                :errors="errors"

              >
              </AutoComplete>
            </ValidationProvider>

            <v-row style="width: 100%;">
              <v-flex xs8 class="mr-2">
                <Search
                  v-model="filters.search"
                  :label="$t('SEARCH')"
                  prepend-icon="search"
                  :delay="500"
                />
              </v-flex>
              <v-flex xs3 class="mr-2">
                <Search
                  v-model="filters.searchAuthor"
                  :label="$t('SEARCH_AUTHOR')"
                  prepend-icon="search"
                  :delay="500"
                />
              </v-flex>
              <v-spacer></v-spacer>
              <!--v-flex xs2 class="mr-5">
                <v-btn
                  @click="loadLastBookAssigned"
                  :disabled="!getLastBookAssigned.length"
                  color="primary"
                >{{ $t("LOAD_LAST_ASSIGNMENT") }} ({{ getLastBookAssigned.length }})
                </v-btn>
              </!v-flex-->
            </v-row>
            <v-row>
              <v-col
                cols="12"
              >
              <ValidationProvider
              rules="required"
              vid="book_id"
              :name="$t('fields.book').toLowerCase()"
              v-slot="{ errors }"
            >

              <v-data-table
                v-model="bookSelected"
                :single-select="false"
                :headers="headers"
                :items="books"
                show-select
                item-key="id"
                :server-items-length="totalItems"
                :no-data-text="$t('NO_DATA')"
                :no-results-text="$t('NO_DATA')"
                hide-default-footer
                :options.sync="pagination"
                :loading="loadingBook"
                class="elevation-1"
              >
                <template v-slot:item.qty="{ item }">
                     {{ getQuantity(item.warehouses) }}
                </template>
              </v-data-table>
              <div class="text-xs-center pt-2">
                  <Paginator
                    :total-items="totalItems"
                    :page.sync="pagination.page"
                    :items-per-page.sync="pagination.itemsPerPage"
                    @change="fetchBooks"
                  />
              </div>

              </ValidationProvider>
              </v-col>


            </v-row>


            <v-row>
              <v-col
                cols="12"
              >
                  <ValidationProvider
                    rules="required"
                    :name="$t('fields.book_type').toLowerCase()"
                    v-slot="{ errors }"
                >
                  <v-select
                    :items="bookType"
                    v-model="formTmp.book_type"
                    item-text="name"
                    item-value="id"
                    :label="$t('fields.book_type')"
                    :error-messages="errors"
                  >
                  </v-select>
                </ValidationProvider>

                <ValidationProvider
                    rules="required"
                    :name="$t('fields.type_shipping').toLowerCase()"
                    v-slot="{ errors }"
                >
                  <v-select
                    :items="shippingType"
                    @change="getAddressByShippingMethod()"
                    v-model="formTmp.shipping_type_id"
                    item-text="name"
                    item-value="id"
                    :label="$t('fields.type_shipping')"
                    :error-messages="errors"
                  >
                  </v-select>
                </ValidationProvider>

                <ValidationProvider
                    rules="required"
                    vid="address"
                    v-if="enableAddress"
                    :name="$t('fields.address').toLowerCase()"
                    v-slot="{ errors }"
                >
                  <v-select
                    :items="addresses"
                    v-model="formTmp.address"
                    item-text="name"
                    item-value="id"
                    :label="$t('fields.address')"
                    :error-messages="errors"
                    return-object
                  >
                  </v-select>
                </ValidationProvider>
              </v-col>
            </v-row>

            </v-card-text>
            </v-card>
            </ValidationObserver>
            </v-col>

            <v-col
              cols=12
              class="mt-10"
            >
              <v-card
                v-if="otherPropagandistBooks.length"
                class="mb-4"
              >
                <v-card-title class="subtitle-1">
                  {{ $t('ASSIGNED_BOOKS_OTHER_PROPAGANDISTS') }}
                </v-card-title>
                <v-card-text>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">{{ $t('fields.isbn') }}</th>
                          <th class="text-left">{{ $t('fields.title') }}</th>
                          <th class="text-left">{{ $t('fields.volume') }}</th>
                          <th class="text-left">{{ $t('fields.propagandist') }}</th>
                          <th class="text-left">{{ $t('fields.date') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(assignedBook, index) in otherPropagandistBooks"
                          :key="index"
                        >
                          <td>{{ assignedBook.isbn }}</td>
                          <td>{{ assignedBook.title }}</td>
                          <td>{{ assignedBook.volume }}</td>
                          <td>{{ assignedBook.propagandist_name }}</td>
                          <td>{{ formatAssignedAt(assignedBook.assigned_at) }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
              <v-alert
                v-if="duplicateWarnings.length"
                type="warning"
                prominent
                dismissible
                class="mt-1 mb-4"
                @input="duplicateWarnings = []"
              >
                <div class="font-weight-bold mb-2">Attenzione: i seguenti libri sono già stati assegnati a questo docente nell'anno scolastico in corso</div>
                <div v-for="(warning, index) in duplicateWarnings" :key="index">
                  <strong>{{ warning.isbn }}</strong> - {{ warning.title }} (assegnato da <strong>{{ warning.propagandist_name }}</strong> il {{ warning.assigned_at }})
                </div>
              </v-alert>
             <v-card
                class="mt-0 mb-10"
              >
                <v-card-actions>
                  <v-btn
                    @click="addToList"
                    color="primary"
                    :disabled="!bookSelected.length"
                  >{{ $t("ADD") }} ({{bookSelected.length}})
                  </v-btn>
                  <v-btn
                    :disabled="enableSaveBtn"
                    @click="save"
                    color="primary"
                  >
                    {{ $t('SAVE') }}
                  </v-btn>
                  <v-btn @click="cancel">
                    {{ $t('CANCEL') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
              <v-card>
                <v-card-text>
                <v-simple-table
                  fixed-header
                  height="600px"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          {{$t('fields.teacher')}}
                        </th>
                        <th class="text-left">
                          {{$t('fields.isbn')}}
                        </th>
                        <th class="text-left">
                          {{$t('fields.book')}}
                        </th>
                        <th class="text-left">
                          {{$t('fields.type_shipping')}}
                        </th>
                        <th class="text-left">
                          {{$t('fields.book_type')}}
                        </th>
                        <th class="text-left">
                          {{$t('fields.address')}}
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in form.assigned"
                        :key="item.id"
                      >
                        <td>{{ item.teacher }}</td>
                        <td>{{ item.isbn }}</td>
                        <td>{{ item.book }}</td>
                        <td>{{ item.type_shipping }}</td>
                        <td>{{ item.book_type }}</td>
                        <td>{{ item.address }}</td>
                        <td>
                          <v-layout row wrap>
                            <v-flex>
                              <v-btn
                                icon
                                color="red"
                                @click="deleteItem(index)"
                              >
                                <v-icon>cancel</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-else>
          <v-row
            class="mb-12"
            no-gutters
          >
          <v-col
            cols="12"
          >
            <v-alert
              color="error"
            >
              <div class="text-h6">
                {{ $t('error_book_assigned_access_defined') }}
              </div>
              {{ $t('error_book_assigned_access_defined_is_not_propagandist') }}
            </v-alert>
          </v-col>

          </v-row>
        </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
  import { mapActions, mapState, mapGetters } from 'vuex';

  import { booksService } from '../../../utils/services/books.service';
  import { teachersService } from '../../../utils/services/teachers.service';
  import { teachersSchoolsService } from '../../../utils/services/teachersSchools.service';
  import { campaignsService } from '../../../utils/services/campaigns.service';
  import AutoComplete from '../../shared/Inputs/AutoComplete';
  import Search from '../../shared/Inputs/Search.vue';
  import TeacherCommonInfo from '../../app/Teachers/TeacherCommonInfo.vue';
  import Paginator from '../../shared/Paginator';

  import { DeliveryMethods } from '../../../utils/constants/delivery-methods';
  import { BookTypes } from '../../../utils/constants/book-constants';

  export default {
    name: 'CampaignTeacherModal',
    components: {
      AutoComplete,
      Search,
      TeacherCommonInfo,
      Paginator,
    },
    data() {
      return {
        stored: null,
        // editTeacher: 0,
        books: [],
        bookSelected: [],
        teachers: [],
        headers: [
          { text: '', value: '' },
          { text: this.$t('fields.isbn'), value: 'isbn' },
          { text: this.$t('fields.author'), value: 'author' },
          { text: this.$t('fields.title'), value: 'title' },
          { text: this.$t('fields.volume'), value: 'volume', sortable: true },
          { text: this.$t('fields.year'), value: 'pubblication_year', sortable: true },
          { text: this.$t('fields.editor'), value: 'editor', sortable: true },
          { text: this.$t('fields.stock'), value: 'qty', sortable: false },
        ],
        teacher: {},
        book: {},
        schoolAddress: [],
        shippingType: [],
        bookType: [],
        addresses: [],
        searchTeacher: null,
        formTmp: {
          address: null,
          shipping_type_id: null,
          book_id: null,
          book_type: null,
        },

        form: {
          assigned: [],
          auto_assignment: false,
        },
        filters: {
          search: '',
          searchTeacher: '',
          searchAuthor: '',
        },
        teacherAssignedBooks: [],
        duplicateWarnings: [],
        loading: false,
        saving: false,
        loadingBook: false,
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [true],
          sortBy: ['title'],
        },
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
      ...mapGetters('user', ['currentUser']),
      enableAddress() {
        const allowed = [DeliveryMethods.HOME, DeliveryMethods.SCHOOL];
        return allowed.includes(this.formTmp.shipping_type_id);
      },
      enableSaveBtn() {
        return !(this.form.assigned.length) || this.saving;
      },
      requestFilters() {
        const filters = {
          search: this.filters.search,
          search_author: this.filters.searchAuthor,
          in_warehouse: true,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },

      getLastBookAssigned() {
        let data = [];
        if (localStorage.getItem('campaign-last-books')) {
          const parsedData = JSON.parse(localStorage.getItem('campaign-last-books'));
          data = Array.isArray(parsedData) ? parsedData : [];
        }


        return data.map(x => x.book_id);
      },

      getLastSearch() {
        return localStorage.getItem('campaign-last-books-search');
      },

      otherPropagandistBooks() {
        if (!this.currentUser || !this.currentUser.user) {
          return [];
        }
        const currentId = Number(this.currentUser.user.id);
        return this.teacherAssignedBooks.filter(book => Number(book.propagandist_id) !== currentId);
      },
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      ...mapActions('confirm', ['showConfirm']),


     clearTeacher() {
       this.teacher = {};
       this.teacherAssignedBooks = [];
       this.duplicateWarnings = [];
       this.formTmp = {
          address: null,
          shipping_type_id: null,
          book_id: null,
          book_type: null,
        };
     },

      getQuantity(warehouses) {
        let str = '';
        warehouses.forEach(warehouse => {
          str += `${warehouse.name}: ${warehouse.pivot.qty}`;
        });
        return (str) || 0;
      },

      formatAssignedAt(value) {
        // Data grezza dal DB, in UTC
        return this.$options.filters.utcTime(value, 'DD/MM/YYYY');
      },

      async searchTeachers(val) {
        if (val !== null) {
          this.filters.searchTeacher = val;
          await this.fetchTeachers();
        }
      },

      getShippingMethods() {
        Object.keys(DeliveryMethods).forEach(method => {
          this.shippingType.push({ id: method, name: this.$t(`delivery_methods.${method}`) });
        });
      },

      getBookTypes() {
        Object.keys(BookTypes).forEach(type => {
          this.bookType.push({ id: type, name: this.$t(`book_types.${type}`) });
        });
      },

      async loadLastBookAssigned() {
        this.fetchSelectedBooksByIds(this.getLastBookAssigned);
        // reset localstorage after load
        localStorage.setItem('campaign-last-books', '');
      },

      setLastSearch(data) {
        localStorage.setItem('campaign-last-books-search', data);
      },

      async addToList() {
        const isValid = await this.$refs.formTmp.validate();
        if (isValid) {
          this.duplicateWarnings = [];
          this.bookSelected.forEach(currentBook => {
            let addBook = 1;
            if (this.form.assigned.some(x => x.book_id === currentBook.id)) {
              if (!confirm(this.$t('ARE_YOU_SURE'))) {
                addBook = 0;
              }
            }

            if (['DIRECT', 'OFFICE'].includes(this.formTmp.shipping_type_id)) {
              // il libro non è presente in nessun magazzino
              if (!currentBook.warehouses.length) {
                this.showToast({ type: 'error', message: this.$t('BOOK_NOT_AVAILABLE_IN_WAREHOUSE') });
                // Show alert
                addBook = 0;
              }
            }

            // Consegna a casa senza un indirizzo reale: il pacco non verrebbe mai consegnato
            if (this.formTmp.shipping_type_id === DeliveryMethods.HOME
              && (!this.formTmp.address || !this.formTmp.address.id)) {
              this.showToast({ type: 'error', message: this.$t('HOME_DELIVERY_ADDRESS_REQUIRED') });
              addBook = 0;
            }

            // Check se il libro è già stato assegnato al docente nell'anno scolastico in corso
            const existingAssignment = this.teacherAssignedBooks.find(
              x => x.book_id === currentBook.id,
            );
            if (existingAssignment) {
              this.duplicateWarnings.push({
                isbn: existingAssignment.isbn,
                title: existingAssignment.title,
                propagandist_name: existingAssignment.propagandist_name,
                assigned_at: this.formatAssignedAt(existingAssignment.assigned_at),
              });
            }

            if (addBook) {
              this.form.assigned.push({
              isbn: currentBook.isbn,
              book: currentBook.title,
              book_id: currentBook.id,
              teacher: `${this.teacher.surname} ${this.teacher.name}`,
              teacher_id: this.teacher.id,
              type_shipping: this.$t(`delivery_methods.${this.formTmp.shipping_type_id}`),
              type_shipping_method: this.formTmp.shipping_type_id,
              address: (this.formTmp.address) ? this.formTmp.address.name : '',
              address_id: (this.formTmp.address) ? this.formTmp.address.id : 0,
              book_type: this.$t(`book_types.${this.formTmp.book_type}`),
            });
            }
          });
          // reset book selected
          this.bookSelected = [];
          this.resetForm();
        }
      },

      deleteItem(index) {
        if (index > -1) {
          this.form.assigned.splice(index, 1);
        }
      },

      async fetchSelectedBooksByIds(bookIds) {
        await booksService.index({
          filters: { ids: bookIds },
        })
          .then(response => {
            this.bookSelected = response.data.data;
        });
      },

      async fetchBooks(forcePage) {
        this.loadingBook = true;
        const { page, itemsPerPage } = this.pagination;
        return booksService.index({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.books = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );

            this.setLastSearch(this.filters.search);
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loadingBook = false;
          });
      },

      async fetchSchoolTeacher(id) {
        return teachersSchoolsService.index(id)
        .then(response => {
            this.schoolAddress = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      resetForm() {
        // this.formTmp.address = null;
        // this.formTmp.shipping_type_id = null;
        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.formTmp.reset();
        });
      },

      fetchTeachers() {
        return teachersService.index({
          filters: {
            search: this.filters.searchTeacher,
            sortBy: ['surname', 'name'],
            sortDesc: [false, false],
          },
        })
        .then(response => {
            this.teachers = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async fetchTeacherAndSchool(id) {
        if (id > 0) {
          await this.fetchTeacher(id);
          await this.fetchSchoolTeacher(id);
          await this.fetchTeacherAssignedBooks(id);
        }
      },

      async fetchTeacherAssignedBooks(teacherId) {
        return campaignsService.checkTeacherBooks({ teacher_id: teacherId })
          .then(response => {
            this.teacherAssignedBooks = response.data;
          })
          .catch(() => {
            this.teacherAssignedBooks = [];
          });
      },

      fetchTeacher(id) {
        return teachersService.get(id)
        .then(response => {
            this.teacher = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      getAddressByShippingMethod() {
        this.addresses = [];
        if (this.formTmp.shipping_type_id === DeliveryMethods.HOME) {
          this.teacher.addresses.forEach(address => {
            // Scarta gli indirizzi senza via: l'anagrafica crea sempre un indirizzo
            // di default anche vuoto, che non è una destinazione reale.
            if (address.street && address.street.trim()) {
              this.addresses.push({
                id: address.id,
                name: address.street,
              });
            }
          });
        }

        if (this.formTmp.shipping_type_id === DeliveryMethods.SCHOOL) {
          this.schoolAddress.forEach(address => {
            this.addresses.push({
              id: address.address_id,
              name: `${address.options_locations.branch_code} ${address.school_name} ${address.street} ${address.city }`,
            });
          });
        }

        if (this.addresses.length === 1) {
          this.formTmp.address = this.addresses[0];
        }
      },

      async save() {
        const isValid = this.form.assigned.length;
        if (isValid && !this.saving) {
            if (this.options.onSave) {
              this.saving = true;
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  console.log(error);
                  // this.handleError(error, this.errors);
              })
              .finally(() => {
                  this.saving = false;
                  this.loadingModal(false);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
    },

    async created() {
      this.loadingModal(true);
      this.filters.search = this.getLastSearch;
      this.getShippingMethods();
      this.getBookTypes();
      this.fetchBooks(1);
      if (this.data.stored.teacher_id) {
        await this.fetchTeacherAndSchool(this.data.stored.teacher_id);
        await this.fetchTeacher(this.data.stored.teacher_id);
        this.filters.searchTeacher = this.teacher.fullname;
        await this.fetchTeachers();
        this.searchTeacher = this.teacher.id;
      }
      this.loadingModal(false);
    },
    watch: {
      teacher: {
        deep: true,
        handler(val) {
          this.formTeacher = val;
        },
      },
      filters: {
        deep: true,
        handler() {
          this.fetchBooks(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchBooks(1);
          }
        },
      },

    },
  };
</script>
<style lang="scss">
  .list-info{
    list-style-type: none;
  }
  .property-list{
    display: flex;
    list-style-type: none;
    li {
      padding-left: 5px;
    }
  }
</style>
